import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
    ClaimNotificationActionService,
    ClaimNotificationDataService,
    ClaimNotificationInterface,
    RelationDataService,
    RelationInterface,
    SaveClaimNotificationPayloadInterface,
} from 'outshared-lib';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'ins-claim-notification-container',
    template: `
        <ins-claim-notification
            [relation]="relation$ | async"
            [claimNotification]="claimNotification"
            (submitted)="onSubmitted($event)"
        ></ins-claim-notification>
    `,
})
export class ClaimNotificationContainer implements OnInit, OnDestroy {
    public relation$: Observable<RelationInterface> = this.relationDataService.getRelation$();
    public claimNotification: ClaimNotificationInterface;

    private subscription: Subscription;

    constructor(
        private relationDataService: RelationDataService,
        private claimNotificationDataService: ClaimNotificationDataService,
        private claimNotificationActionService: ClaimNotificationActionService,
        private route: ActivatedRoute
    ) {}

    public ngOnInit(): void {
        this.subscription = new Subscription();

        const getNotification: Subscription = this.claimNotificationDataService
            .getNotifications$()
            .subscribe((claimNotification) => (this.claimNotification = claimNotification[0]));

        const queryParams: Subscription = this.route.queryParams.subscribe((params) => this.handleQueryParams(params));

        this.subscription.add(getNotification);
        this.subscription.add(queryParams);
    }

    public ngOnDestroy(): void {
        this.claimNotificationActionService.resetClaimNotification();
        this.subscription.unsubscribe();
    }

    public onSubmitted($event: SaveClaimNotificationPayloadInterface): void {
        const saveClaimNotification: Subscription = this.claimNotificationActionService
            .saveClaimNotification$($event)
            .subscribe();
        this.subscription.add(saveClaimNotification);
    }

    private handleQueryParams(queryParams: Params): void {
        const caseSequenceNumber = Number(queryParams.d);

        if (!caseSequenceNumber) {
            return;
        }

        const getClaimNotification: Subscription = this.claimNotificationActionService
            .getClaimNotification$({ caseSequenceNumber })
            .subscribe();

        this.subscription.add(getClaimNotification);
    }
}
